// src/i18n.js
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend"; // Change this import

i18next
    .use(Backend) // Use http-backend instead of resourcesToBackend
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: ["en", "ru", "hy"],
        load: "languageOnly",
        fallbackLng: "hy",
        detection: {
            order: ["localStorage", "cookie", "htmlTag"],
            caches: ["localStorage"],
        },
        // debug: process.env.NODE_ENV === "development",
        ns: [
            "about", "blog", "choose", "data", "error", "estate",
            "faq", "freeconsult", "home", "legal", "ourspace", "rev", "seales"
        ],
        defaultNS: "home",
        backend: {
            loadPath: "https://sievn-bucket.fra1.cdn.digitaloceanspaces.com/i18n/{{ns}}/{{lng}}.json",
        },
        interpolation: {
            escapeValue: false,
            formatSeparator: ",",
        },
        react: {
            useSuspense: false,
            bindI18n: "languageChanged",
        },
    });

export default i18next;